import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Play } from "lucide-react";
import Magnetic from "@/components/shared/Magnetic";

export default function Hero() {
  return (
    <section
      data-testid="home-hero"
      className="relative pt-24 md:pt-32 pb-8 md:pb-14 overflow-hidden spotlight"
      onMouseMove={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        e.currentTarget.style.setProperty('--mx', `${e.clientX - r.left}px`);
        e.currentTarget.style.setProperty('--my', `${e.clientY - r.top}px`);
      }}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 -left-20 w-[500px] h-[500px] rounded-full bg-white/[0.03] blur-3xl" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full bg-white/[0.02] blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-8">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.05 }}
              className="font-display font-bold text-5xl md:text-6xl lg:text-[5.25rem] leading-[0.95] tracking-tight text-balance"
              data-testid="hero-headline"
            >
              We run the marketing engine<br />
              behind <span className="italic font-light text-shimmer">today's biggest music.</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.15 }}
              className="mt-8 max-w-xl text-lg md:text-xl text-zinc-400 leading-relaxed"
              data-testid="hero-subheadline"
            >
              A new-gen music marketing agency. Fair rates, full transparency, and a
              roster we actually manage, not rent. Same infrastructure the majors
              rely on, without the retainer bill.
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.25 }}
              className="mt-10 flex flex-wrap items-center gap-4"
            >
              <Magnetic radius={140} strength={0.4}>
                <Link
                  to="/contact"
                  data-testid="hero-primary-cta"
                  className="inline-flex items-center gap-2 bg-white text-black font-semibold rounded-full px-6 py-3.5 hover:bg-zinc-200 btn-magnetic glow-cta"
                >
                  Book Strategy Call <ArrowUpRight size={18} />
                </Link>
              </Magnetic>
              <Link
                to="/case-studies"
                data-testid="hero-secondary-cta"
                className="inline-flex items-center gap-2 border border-white/20 text-white font-medium rounded-full px-6 py-3.5 hover:bg-white/5 transition-all"
              >
                <Play size={16} /> View Case Studies
              </Link>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
